import getPrefix from './getPrefix';
import isProduction from './isProduction';

const getAdUnitPrefix = (url) => (isProduction(url)
  ? getPrefix(url) : 'testads');

export default getAdUnitPrefix;
